
/**
 * Displays the SAFA name.
 */
export default {
  name: "SafaName",
};
